import { ManageRolesTableProperties } from "PFApp/activities/manage_roles/parts/table_properties/manage_roles_table_properties";
import { AddRoleWithSubtemplateButton } from "PFApp/components/activity_commons/add_role_with_subtemplate_button";
import { Inline } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { useAddDraftRole } from "../hooks/use_add_draft_role";
import { isManageRolesAddRoleEnabled } from "../manage_roles.utils";
import css from "../manage_roles_page.module.scss";

type ToolbarProps = {
  totalRoles: number;
  isLoading: boolean;
};

export const Toolbar = ({ totalRoles, isLoading }: ToolbarProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });
  const { addDraftRole } = useAddDraftRole();

  return (
    <Inline className={css.toolbar} gap="spacingLg" alignItems="center" spread>
      {isLoading ? (
        <LoadingDots />
      ) : (
        <Typography variant="bodyRegular" qaId="ManageRoles.Toolbar.RolesCount">
          {t("rolesCount", { count: totalRoles })}
        </Typography>
      )}
      <Inline gap="spacingSm" alignItems="center">
        <ManageRolesTableProperties />
        {isManageRolesAddRoleEnabled() && (
          <AddRoleWithSubtemplateButton
            onChange={addDraftRole}
            qaId="ManageRoles.Toolbar.AddRoleButton"
            optionQaIdPrefix="ManageRoles.Toolbar.AddRoleSubtemplateOption"
          />
        )}
      </Inline>
    </Inline>
  );
};
